import Config from "config/config";
import { useEffect, useState } from "react";
import YouTube from "react-youtube";
import Button from "./Button";

export default function Bubble(props: { title: string, desc?: string, videoId ?: string, className?: string}){
    const {title, desc = '', videoId = null, className} = props ;
    const [ isShow, setIsShow ] = useState<boolean>();
    useEffect(() => {
        setTimeout(() => {
            setIsShow(true);
        }, 500);
    },[])
    return (
        <div
            style={{ width: videoId ? '500px' : desc ? '280px' : 'auto'}} 
            onClick={(e) => e.stopPropagation()}
            className={`absolute ${isShow ? '' : 'hidden'} left-[50%] translate-y-[0px] pt-[25px] translate-x-[-50%] z-[999999]  ${className}`}>
            <div className="bg-[#000000] px-[22px] py-[20px] text-[#ffffff] rounded-[10px] relative">
                <div className="absolute left-[50%] top-[-10px] translate-x-[-50%] w-[40px] h-[15px] overflow-hidden">
                    <div className="absolute translate-y-[5px] left-[50%] translate-x-[-50%] w-[20px] h-[20px] rotate-45 bg-[#000000]"></div>
                </div>
                
                {
                    videoId && 
                    <div className="">
                        <video src={Config.cdnDomain + `/editor/function/${videoId}.mp4`} muted autoPlay className="rounded-[5px]"></video>
                        {/* <YouTube videoId={videoId} opts={{
                            width: '100%',
                            height: '340px',
                            playerVars : {
                                autoplay: 1
                            }
                        }} ></YouTube> */}
                    </div>
                }
                
                <p className={`font-bold text-[14px] ${videoId ? 'mt-[15px]' : ''}`}>{title}</p>
                {
                    !!desc && <p>{desc}</p>
                }
                {
                    videoId && 
                    <Button txt="Learn more" className="mt-[15px] py-[6px]" clickEvent={() => window.open('https://www.mockuplabs.ai/tutorials')}/>
                }
            </div>
        </div>
    )
}  